import { render, staticRenderFns } from "./kanban-view.vue?vue&type=template&id=17ea4984&"
import script from "./kanban-view.vue?vue&type=script&lang=js&"
export * from "./kanban-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports